import { ReactNode } from 'react'
import { useDraggable } from '@dnd-kit/core'

import { TPlayer } from '@/common/types'

type DraggableProps = {
    children: ReactNode
    player: TPlayer
    position: {
        index?: number
        colIndex?: number
        rowIndex?: number
    }
    isSubstitution: boolean
    placement: string
}
export function Draggable({ children, player, position, isSubstitution, placement }: DraggableProps) {
    const { attributes, listeners, setNodeRef } = useDraggable({
        id: `${player.name}-${player.id}-${placement}`,
        data: { player, position, isSubstitution, initialPlacement: placement },
    })

    return (
        <div ref={setNodeRef} {...attributes} {...listeners}>
            {children}
        </div>
    )
}
